/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    if (window.location.hash) {
      var element = document.querySelector(window.location.hash);
      if (element) {
        window.scrollTo({ top: element.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
      }
    }
  }, 0)
});

// Button Icon And Text============================================

document.addEventListener("DOMContentLoaded", function () {
  const BUTTON_SELECTOR = ".custom-clear-it-new #AddToCart, .custom-clear-it-new-v2-phase1 #AddToCart, .custom-clear-it-new-v2-phase3 #AddToCart, .custom-light-up-new #AddToCart, .custom-light-up-new-v2-phase3 #AddToCart, .custom-light-up-new-v2-phase2 #AddToCart, .custom-collagen-new #AddToCart, .custom-collagen-new-v2-phase1 #AddToCart, .custom-collagen-new-v2-phase3 #AddToCart";

  function enhanceAddToCartButton() {
    const buttons = document.querySelectorAll(BUTTON_SELECTOR);
    if (!buttons.length) return;

    buttons.forEach(btn => {
      const textWrapper = btn.querySelector(".loader-button__text");
      if (!textWrapper) return;

      // Prevent double injection
      if (textWrapper.querySelector(".atc-main")) return;

      // Get original button text
      const textNode = Array.from(textWrapper.childNodes)
        .find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());

      const buttonText = textNode
        ? textNode.textContent.trim()
        : "ADD TO CART";

      textWrapper.innerHTML = `
        <span class="atc-main">
          <span class="atc-icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_715_1834)">
                <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.05964 14 11.75 14Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_715_1834">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>

          <span class="atc-text">${buttonText}</span>
        </span>

        <span class="atc-subtext">
          90 days money back guarantee
        </span>
      `;
    });
  }

  // Initial run
  enhanceAddToCartButton();

  // Observe button changes (variant switching re-renders it)
  const observer = new MutationObserver(() => {
    enhanceAddToCartButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// ==============STICKY ATC ICON AND TEXT================

(function () {
  const BTN_SELECTOR = ".custom-clear-it-new #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {
  const BTN_SELECTOR = ".custom-clear-it-new-v2-phase1 #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  const BTN_SELECTOR = ".custom-clear-it-new-v2-phase3 #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  const BTN_SELECTOR = ".custom-light-up-new #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {
  const BTN_SELECTOR = ".custom-collagen-new #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
